import styled from 'styled-components';

export const LayoutContent = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: stretch;
`;
